import React, { useEffect } from 'react';
import { Drawer, Form, Input, Button, Select, Space, DatePicker } from 'antd';
import * as actions from 'store/actions/AuthActions';
import { useNotification } from 'NotificationContext';
import dayjs from 'dayjs';

const { TextArea } = Input;

const DealActivityForm = ({ visible, onClose, dealId, instance, onSuccess }) => {
    const [form] = Form.useForm();
    const notify = useNotification();

    useEffect(() => {
        if (instance) {
            const formValues = {
                ...instance,
                activity_date: instance.activity_date ? dayjs(instance.activity_date) : null
            };
            form.setFieldsValue(formValues);
        } else {
            form.resetFields();
        }
    }, [instance, form]);

    const handleSubmit = async (values) => {
        const data = {
            ...values,
            deal: dealId
        };

        try {
            if (instance) {
                const response = await actions.updateDealActivity(data, instance.id);
                if (response) {
                    notify('success', 'Activity updated successfully');
                    onSuccess();
                }
            } else {
                const response = await actions.addDealActivity(data);
                if (response && response.status === 201) {
                    notify('success', 'Activity added successfully');
                    onSuccess();
                }
            }
        } catch (error) {
            notify('error', 'Failed to save activity');
        }
    };

    return (
        <Drawer
            title={instance ? 'Edit Activity' : 'Add Activity'}
            width={500}
            onClose={onClose}
            open={visible}
            footer={
                <Space style={{ float: 'right' }}>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="primary" onClick={() => form.submit()}>
                        {instance ? 'Update' : 'Add'}
                    </Button>
                </Space>
            }
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
            >
                <Form.Item
                    label="Activity Type"
                    name="activity_type"
                    rules={[{ required: true, message: 'Please select activity type!' }]}
                >
                    <Select placeholder="Select activity type">
                        <Select.Option value="MEETING">Meeting</Select.Option>
                        <Select.Option value="CALL">Call</Select.Option>
                        <Select.Option value="WHATSAPP">WhatsApp</Select.Option>
                        <Select.Option value="EMAIL">Email</Select.Option>
                        <Select.Option value="DEMO">Demo</Select.Option>
                        <Select.Option value="FOLLOW_UP">Follow Up</Select.Option>
                        <Select.Option value="PROPOSAL">Proposal</Select.Option>
                        <Select.Option value="NEGOTIATION">Negotiation</Select.Option>
                        <Select.Option value="SITEVISIT">Site Visit</Select.Option>
                        <Select.Option value="WEBINAR">Webinar</Select.Option>
                        <Select.Option value="TRAINING">Training</Select.Option>
                        <Select.Option value="NETWORKING">Networking</Select.Option>
                        <Select.Option value="FEEDBACK">Feedback</Select.Option>
                        <Select.Option value="PRESENTATION">Presentation</Select.Option>
                        <Select.Option value="ONBOARDING">Onboarding</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Activity Date"
                    name="activity_date"
                    rules={[{ required: true, message: 'Please select activity date!' }]}
                >
                    <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item
                    label="Status"
                    name="status"
                    rules={[{ required: true, message: 'Please select status!' }]}
                >
                    <Select placeholder="Select status">
                        <Select.Option value="PENDING">Pending</Select.Option>
                        <Select.Option value="CONTACTED">Contacted</Select.Option>
                        <Select.Option value="COLD">Cold</Select.Option>
                        <Select.Option value="WARM">Warm</Select.Option>
                        <Select.Option value="HOT">Hot</Select.Option>
                        <Select.Option value="COMPLETED">Completed</Select.Option>
                        <Select.Option value="CANCELLED">Cancelled</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Notes"
                    name="notes"
                >
                    <TextArea rows={4} placeholder="Enter activity notes" />
                </Form.Item>
            </Form>
        </Drawer>
    );
};

export default DealActivityForm;
